import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOADREMINDERS = 'react/common/reminders/LOADREMINDERS',
    LOADREMINDERS_PENDING = 'react/common/reminders/LOADREMINDERS_PENDING',
    LOADREMINDERS_FULFILLED = 'react/common/reminders/LOADREMINDERS_FULFILLED',
    LOADREMINDERS_REJECTED = 'react/common/reminders/LOADREMINDERS_REJECTED',
    
    SAVEREMINDER = 'react/common/reminders/SAVEREMINDER',
    SAVEREMINDER_PENDING = 'react/common/reminders/SAVEREMINDER_PENDING',
    SAVEREMINDER_FULFILLED = 'react/common/reminders/SAVEREMINDER_FULFILLED',
    SAVEREMINDER_REJECTED = 'react/common/reminders/SAVEREMINDER_REJECTED',
    
    LOADCONTACTSREMINDERS = 'react/common/reminders/LOADCONTACTSREMINDERS',
    LOADCONTACTSREMINDERS_PENDING = 'react/common/reminders/LOADCONTACTSREMINDERS_PENDING',
    LOADCONTACTSREMINDERS_FULFILLED = 'react/common/reminders/LOADCONTACTSREMINDERS_FULFILLED',
    LOADCONTACTSREMINDERS_REJECTED = 'react/common/reminders/LOADCONTACTSREMINDERS_REJECTED',

    ADDREMINDER = 'react/common/reminders/ADDREMINDER',
    ADDREMINDER_PENDING = 'react/common/reminders/ADDREMINDER_PENDING',
    ADDREMINDER_FULFILLED = 'react/common/reminders/ADDREMINDER_FULFILLED',
    ADDREMINDER_REJECTED = 'react/common/reminders/ADDREMINDER_REJECTED',

    CREATENEWREMINDER = 'react/common/reminders/CREATENEWREMINDER',

    ADDBLOCKACCESSDATE = 'react/common/contacts/ADDBLOCKACCESSDATE',

    // USERCONNECTED = 'react/common/reminders/USERCONNECTED',
    // USERDISCONNECTED = 'react/common/reminders/USERDISCONNECTED',
    
    OTHER_ACTION = 'react/common/reminders/__any_other_action__',
}

export type Types = IBaseAction<Keys>;